import { copyTextBankActions } from './constant';

const { REQUEST_SEARCH_CPT_CODES } = copyTextBankActions;

export const getCPTCodesDescription = (cptCode: string) => {
  return {
    type: REQUEST_SEARCH_CPT_CODES,
    cptCode,
  };
};
